import { render } from "./WeekTrainerCycleU19.vue?vue&type=template&id=006c4013"
import script from "./WeekTrainerCycleU19.vue?vue&type=script&lang=js"
export * from "./WeekTrainerCycleU19.vue?vue&type=script&lang=js"

import "./WeekTrainerCycleU19.vue?vue&type=style&index=0&id=006c4013&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__